import { render, staticRenderFns } from "./other-earnings-charge-form.vue?vue&type=template&id=0991516a&"
import script from "./other-earnings-charge-form.vue?vue&type=script&lang=js&"
export * from "./other-earnings-charge-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports